import "./floating-button.scss";
import channels from "../channels/channels";
import "./floating-button.functions";
import { environment } from "../../environments/evironment";
import common from "../../helpers/common";

export default {
  /**
   * Create a floating button for the DG menu
   * @returns {HTMLDivElement}
   */
  createButton(accountSettings) {
    var channelTemplate = channels.createChannels(accountSettings);

    const button = document.createElement("div");
    button.classList.add("dgWidget");
    button.setAttribute("id", "digital-gate");

    button.innerHTML = `
        <input type="checkbox" name="adminToggle" class="adminToggle" />
        <a class="dgButton ${accountSettings["Style"].Size.CodeName}">
            <img src="${environment.BLOB_URL + accountSettings["FloatingIconName"]}"/>
        </a>
        <div class="dgChannels">
            ${channelTemplate.channelHTML}
        </div>
        ${channelTemplate.windowHTML}
    `;

    const toggleBtn = button.querySelector(".dgButton");

    if (toggleBtn) {
      toggleBtn.addEventListener("click", (e) => {
        e.preventDefault();
        floatingButton.toggleMenu();
      });
    }

    const closeButtons = button.querySelectorAll(".closeIframe");

    closeButtons.forEach((el) => {
      el.addEventListener("click", function (e) {
        e.preventDefault();

        const name = this.getAttribute("data-name");
        const id = this.getAttribute("data-id");

        if (
          window.contentWindow &&
          typeof window.contentWindow.hideIframe === "function"
        ) {
          window.contentWindow.hideIframe(name, id);
        } else {
          console.error("contentWindow.hideIframe no disponible");
        }
      });
    });

    return button;
  },
  /**
   * Create a floating button for the DG Single Channel
   * @returns {HTMLDivElement}
   */
  createSingleChannelButton(accountSettings) {
    var channelTemplate = channels.createChannels(accountSettings);

    const button = document.createElement("div");
    button.classList.add("dgWidget");
    button.setAttribute("id", "digital-gate");

    button.innerHTML = `
        <input type="checkbox" name="adminToggle" class="adminToggle" />
        ${channelTemplate.channelHTML}
        ${channelTemplate.windowHTML}
    `;

    const singleBtn = button.querySelector("[data-channel]");

    if (singleBtn) {
      singleBtn.addEventListener("click", function (e) {
        e.preventDefault();

        const data = this.getAttribute("data-channel");

        if (
          window.channels &&
          typeof window.channels.showChannel === "function"
        ) {
          window.channels.showChannel(data);
        } else {
          console.error("channels.showChannel no disponible");
        }
      });
    }

    const closeButtons = button.querySelectorAll(".closeIframe");

    closeButtons.forEach((el) => {
      el.addEventListener("click", function (e) {
        e.preventDefault();

        const name = this.getAttribute("data-name");
        const id = this.getAttribute("data-id");

        if (
          window.contentWindow &&
          typeof window.contentWindow.hideIframe === "function"
        ) {
          window.contentWindow.hideIframe(name, id);
        } else {
          console.error("contentWindow.hideIframe no disponible");
        }
      });
    });

    return button;
  },
  /**
   * Add account styles in the site
   * @param {*} accountStyle
   */
  loadAccountStyles(accountStyle) {
    if (accountStyle) {
      let styleUrl = `${environment.BASE_URL}assets/accountStyles/${accountStyle}`;
      common.injectExternalStyles(styleUrl);
    }
  },
  /**
   * automatic menu opening
   * @param {*} accountSettings
   */
  showMenuTimeOut(accountSettings) {
    if (
      accountSettings["OpenProactive"] &&
      accountSettings["OpenTimeOut"] > 0
    ) {
      setTimeout(function () {
        floatingButton.toggleMenu("show");
      }, 300);

      var proactiveTimeOut = setTimeout(function () {
        floatingButton.toggleMenu("hide");
        clearTimeout(proactiveTimeOut);
      }, accountSettings["OpenTimeOut"]);
    }
  },
  /**
   * Render the button in the body of the website
   */
  render(accountSettings) {
    accountSettings.ChannelsByAccount =
      accountSettings.ChannelsByAccount.filter(function (item) {
        return item.Status && item.Status === 1;
      });

    var channelLength = accountSettings.ChannelsByAccount.length;
    if (channelLength == 1) {
      const button = this.createSingleChannelButton(accountSettings);
      this.loadAccountStyles(accountSettings["AccountStyles"]);
      document.getElementsByTagName("body")[0].appendChild(button);
    }
    if (channelLength >= 2) {
      const button = this.createButton(accountSettings);
      this.loadAccountStyles(accountSettings["AccountStyles"]);
      document.getElementsByTagName("body")[0].appendChild(button);
      this.showMenuTimeOut(accountSettings);
    }
  },
};
